import * as Yup from 'yup';
export const LoginSchema = Yup.object().shape({
  Email: Yup.string().email("Invalid email").required("Email is required"),
  Password: Yup.string()
    .min(5, "Password must be at least 5 characters")
    .required("Password is required"),
});